import { useCallback } from 'react'

export const useCopyToClipboard = () => {
  const copyToClipboard = useCallback(async (text: string) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text)
        return true
      }

      // Fallback for HTTP or older browsers
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      textArea.style.opacity = '0'
      textArea.style.pointerEvents = 'none'
      textArea.setAttribute('readonly', '')
      document.body.appendChild(textArea)
      textArea.select()
      textArea.setSelectionRange(0, text.length)

      let successful = false
      try {
        successful = document.execCommand('copy')
      } catch (err) {
        //
      }

      document.body.removeChild(textArea)

      if (successful) {
        return true
      }
      throw new Error('execCommand failed')
    } catch {
      alert(`Please copy this text manually:\n\n${text}`)
      return false
    }
  }, [])

  return { copyToClipboard }
}
